import classNames from 'classnames';
import React from 'react';
import { dividerClasses, DividerSC } from './divider.styled';

interface IDividerProps {
  label?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  thickness?: number;
  variant?: 'on-dark' | 'on-light';
}

const Divider: React.FC<IDividerProps> = ({
  label,
  style,
  className,
  thickness = 1,
  variant = 'on-light',
}) => {
  return (
    <DividerSC
      className={classNames(dividerClasses.component, className)}
      style={style}
      thickness={thickness}
      variant={variant}
    >
      {label ? <div className={dividerClasses.content}>{label}</div> : null}
    </DividerSC>
  );
};

export default Divider;
